export const staffConst = {
    MENTORS_LOADED: 'MENTORS_LOADED',
    MENTOR_PATCHED: 'MENTOR_PATCHED',
    CAREERS_PATCHED: 'CAREERS_PATCHED',
    CAREERS_LOADED: 'CAREERS_LOADED',
    UNLOADED: 'STAFF_UNLOADED',
    CAREERS_REMOVED: 'CAREERS_REMOVED',
    MENTORS_REMOVED: 'MENTORS_REMOVED'
};
